import React, { useState } from "react";
import { connect } from "react-redux";
import { ToastNotifications } from "../../context/toast-notifications";
import Toasts from "../toast-notification";
import { addToast, removeToast } from "../../redux/actions";
import defaultTheme from "../../theme/default";
import Snapshot from "./snapshot";
import Details from "./details";

const INSURANCE_SETTINGS_TOAST_ID = "INSURANCE_SETTINGS_TOAST_ID";

const InsuranceSettings = ({
  toasts,
  addToast,
  removeToast,
  theme,
  extendedConfiguration: { insuranceSettings }
}) => {
  const components = { ...defaultTheme, ...theme };
  const { Tabs } = components;

  const [index, setIndex] = useState(insuranceSettings.insurance.payerName ? 0 : 1);

  const handleSaveSuccess = res => {
    addToast({
      id: INSURANCE_SETTINGS_TOAST_ID,
      message: "Your insurace information was successfully updated.",
      variant: "success"
    });
    if (res.data.insurance.payerId) {
      setIndex(0);
    }
  };

  const handleSaveError = () => {
    addToast({
      id: INSURANCE_SETTINGS_TOAST_ID,
      message: "We had trouble confirming your insurance information. Please try again."
    });
  };

  const handleDataFetchError = () => {
    addToast({
      id: INSURANCE_SETTINGS_TOAST_ID,
      message: "Error fetching data."
    });
  };

  const tabContent = (tabIndex, childern) => (
    <div style={{ display: tabIndex === index ? "block" : "none" }}>
      {childern}
    </div>
  );

  return (
    <ToastNotifications components={components}>
      <Toasts toasts={toasts} onClose={toastId => removeToast(toastId)} components={components} />
      <Tabs variant="insurance-settings" titles={["Snapshot", "Details"]} selected={index} onChange={setIndex} />
      {tabContent(0, 
        <Snapshot
          {...insuranceSettings}
          onDataFetchError={handleDataFetchError}
          components={components}
          gotoDetails={setIndex}
        />
      )}
      {tabContent(1, (
        <Details
          {...insuranceSettings}
          onSaveSuccess={handleSaveSuccess}
          onSaveError={handleSaveError}
          components={components}
        />
      ))}
    </ToastNotifications>
  );
};

export default connect(
  ({ tdFlow }) => ({
    toasts:       tdFlow.toasts,
    screenParams: tdFlow.screenParams
  }),
  { addToast, removeToast }
)(InsuranceSettings);
